<template>
  <mk-drawer
    class="ordinary-material-select"
    :visible.sync="show"
    size="820px"
    hide-header
    :before-close="cancel"
  >
    <div class="header">
      <h3>新增小程序资料</h3>
      <i
        class="close iconfont icon-mk-guanbi"
        @click="cancel"
      ></i>
    </div>
    <div class="search-line">
      <div class="left">
        <mk-select
          v-model="fileType"
          width="200"
          class="mr-r-10"
          clearable
          filterable
          placeholder="请选择文件类型"
        >
          <mk-option
            v-for="item in fileTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-input
          v-model="name"
          suffix-icon="el-icon-search"
          width="240"
          placeholder="输入文件名称"
        ></mk-input>
      </div>
      <div class="btn-group">
        <mk-button-biz
          type="primary"
          icon="el-icon-search"
          @click="handleOnSearchClick"
        >
          搜索
        </mk-button-biz>
        <mk-button-biz
          width="60px"
          @click="handleOnResetClick"
        >
          重置
        </mk-button-biz>
      </div>
    </div>
    <div class="table">
      <div class="table-div">
        <mk-table
          v-if="tableMaxHeight"
          :max-height="tableMaxHeight"
          :data="list"
          style="flex:1;"
        >
          <mk-table-column
            width="45"
          >
            <template slot-scope="scope">
              <mk-radio
                v-model="radioCheckedValue"
                :label="scope.row.id"
                @change="change(scope.row)"
              >
                <!-- 用来占位的span，不然就会显示label里面的值 -->
                <span />
              </mk-radio>
            </template>
          </mk-table-column>
          <!-- fileType -->
          <mk-table-column
            label="类型"
            width="100"
          >
            <template slot-scope="scope">
              {{ fileTypeName[scope.row.fileType] }}
            </template>
          </mk-table-column>
          <mk-table-column
            label="标题"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.name }}.{{ scope.row.suffix }}
            </template>
          </mk-table-column>
          <mk-table-column
            label="发布时间"
            prop="createTime"
            width="160"
          >
          </mk-table-column>
        </mk-table>
      </div>
      <list-pagination
        :config="{ total }"
        :current-page="page"
        @current-change="handleOnCurrentChange"
      />
    </div>
    <div class="handle-btn">
      <mk-button-biz
        type="normal"
        @click="cancel"
      >
        取消
      </mk-button-biz>
      <mk-button-biz
        type="primary"
        @click="confirm"
      >
        保存
      </mk-button-biz>
    </div>
  </mk-drawer>
</template>
<script>
import { MKMATERIALSVC } from '@api'
import listPagination from './list-pagination'
export default {
  components: {
    listPagination
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 当前选中的数据：目前是id字段的值
    sectionValue: {
      type: [Array, String, Number],
      default: 0
    }
  },
  data () {
    return {
      tableMaxHeight: 0,
      activeItem: {},
      fileType: '',
      radioCheckedValue: '',
      fileTypeOptions: [
        { label: '文档', value: 1 },
        { label: '表格', value: 2 },
        { label: 'PDF', value: 3 },
        // { label: 'TXT', value: 4 },
        { label: '幻灯片 ', value: 5 },
        { label: '图片', value: 6 },
        { label: '音频', value: 7 },
        { label: '视频', value: 8 }
      ],
      page: 1,
      total: 0,
      list: [],
      name: '',
      fileTypeName: {
        '1': '文档',
        '2': '表格',
        '3': 'PDF',
        '4': 'TXT',
        '5': '幻灯片',
        '6': '图片',
        '7': '音频',
        '8': '视频'
      }
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.table-div', this)
    })
  },
  methods: {
    change (data) {
      this.activeItem = data
      this.radioCheckedValue = data.id
    },
    cancel () {
      this.$emit('cancel')
    },
    async getList () {
      let metas = {
        category: 3,
        page: this.page,
        pageSize: 10
      }

      if (this.fileType) {
        metas.fileType = this.fileType
      }

      if (this.name !== '') {
        metas.name = this.name
      }

      const res = await MKMATERIALSVC.OrdinaryApi.ordinaryListForMiniMaterialGet(metas)
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
      }
    },
    handleOnSearchClick () {
      this.page = 1
      this.getList()
    },
    handleOnResetClick () {
      this.page = 1
      this.fileType = ''
      this.name = ''
    },
    handleOnCurrentChange (e) {
      this.page = e
      this.getList()
    },
    async confirm () {
      if (this.radioCheckedValue) {
        if (this.activeItem.fileType === 4) {
          this.$message({
            type: 'error',
            message: '不可选择TXT文件，请重新选择'
          })
        } else {
          let res = await MKMATERIALSVC.MiniMaterialApi.miniMaterialCreatePost({
            url: this.activeItem.url,
            ordinaryId: this.radioCheckedValue,
            fileSuffix: this.activeItem.suffix,
            title: this.activeItem.name,
            materialType: this.activeItem.fileType,
            status: 0
          })
          if (res.success) {
            this.$message({
              type: 'success',
              message: '新增成功',
              showClose: true
            })
            this.$emit('confirm')
          }
        }
      } else {
        this.$message({
          type: 'error',
          message: '请选择一个资料',
          showClose: true
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .ordinary-material-select {
    .header {
      line-height: 60px;
      box-shadow: 0 1px 0 0 rgba(232, 232, 232, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;

      h3 {
        font-weight: 500;
        font-size: 16px;
        margin-left: 20px;
      }

      .close {
        font-size: 16px;
        cursor: pointer;
        margin-right: 20px;
        color: #bfbfbf;
      }
    }

    .search-line {
      width: calc(100% - 60px);
      margin: 0 auto;
      margin-top: 10px;
      height: 32px;
      display: flex;
      align-items: center;
      // justify-content: space-between;

      .mr-r-10 {
        margin-right: 8px;
      }

      .btn-group {
        margin-left: 8px;
      }
    }

    .table {
      display: flex;
      flex-direction: column;
      width: calc(100% - 60px);
      margin: 0 auto;
      margin-top: 10px;
      height: calc(100vh - 205px);
      margin-bottom: 16px;
      overflow: auto;

      .table-div {
        flex: 1;
        height: 100%;
      }
    }

    .handle-btn {
      width: 100%;
      height: 56px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
      border: 1px solid rgba(232, 232, 232, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
